import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'
import {
  getInventoryGroup,
  getInventoryItem,
  inventoryItemSave,
  inventoryFileDelete,
  inventoryNewItemFilesAdd,
  inventoryNewItemFilesRemove,
  inventoryNewItemFilesClear,
} from '../actions'

import Item from './Item'

const mapStateToProps = state => {
  const countryIsoCode = getFromSettings(state, 'countryIsoCode')

  return {
    isGetGroupInProgress: state.inventory.isGetGroupInProgress,
    getGroupResponse: state.inventory.getGroupResponse,
    group: state.inventory.group,
    isGetItemInProgress: state.inventory.isGetItemInProgress,
    getItemResponse: state.inventory.getItemResponse,
    isSaveItemInProgress: state.inventory.isSaveItemInProgress,
    saveItemResponse: state.inventory.saveItemResponse,
    deleteFileResponse: state.inventory.deleteFileResponse,
    newItemFiles: state.inventory.newItemFiles,
    labels: getFromSettings(state, 'labels', {}),
    isWidgetState: state.appReducer.isWidget,
    countryIsoCode: countryIsoCode,
  }
}

const mapDispatchToProps = {
  getInventoryGroup,
  getInventoryItem,
  inventoryItemSave,
  inventoryFileDelete,
  inventoryNewItemFilesAdd,
  inventoryNewItemFilesRemove,
  inventoryNewItemFilesClear,
}

export default connect(mapStateToProps, mapDispatchToProps)(Item)
